import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import SideBarSkeleton from '../../Component/SideBarSkeleton';
import AutomatedEmailsList from './AutomatedEmailsList';
import AutomatedSmsList from './AutomatedSmsList';
import classes from './AutomatedEmails.module.css';

const tabsConfig = [
  { status: 'emails', tabLabel: 'Automated Emails' },
  { status: 'sms', tabLabel: 'Automated SMS' },
];

const AutomatedEmails = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab');

  const [tabValue, setTabValue] = useState(
    tab && tabsConfig.some((t) => t.status === tab) ? tab : tabsConfig[0].status,
  );

  const onTabChange = (_event, newValue) => {
    setTabValue(newValue);
    setSearchParams({ tab: newValue });
  };

  return (
    <SideBarSkeleton>
      <div className={classes.mainContainer}>
        <div className={classes.headerContainer}>
          <h3>Automated Emails & SMS</h3>
        </div>

        <Box sx={{ width: '100%', typography: 'body1' }}>
          <TabContext value={tabValue}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList
                onChange={onTabChange}
                aria-label="Automated Emails and SMS Tabs"
              >
                {tabsConfig.map((t) => (
                  <Tab key={t.status} label={t.tabLabel} value={t.status} />
                ))}
              </TabList>
            </Box>
            <TabPanel value="emails" style={{ padding: '10px 0 0 0' }}>
              <AutomatedEmailsList />
            </TabPanel>
            <TabPanel value="sms" style={{ padding: '10px 0 0 0' }}>
              <AutomatedSmsList />
            </TabPanel>
          </TabContext>
        </Box>
      </div>
    </SideBarSkeleton>
  );
};

export default AutomatedEmails;
